import PageCard from "features/shared/components/card/PageCard";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { UserEnumDTO } from "features/shared/enums/dynamic/UserEnumDTO";
import FormGroup from "features/shared/forms/components/FormGroup";
import RadioBox from "features/shared/forms/components/radioBox/RadioBox";
import { UseFormHookResult } from "features/shared/forms/hooks/useForm";
import React, { useEffect } from "react";
import MailMethodEmailsSubForm from "./MailMethodEmailsSubForm";
import { useTranslation } from "react-i18next";

type Props = {
  mailMethods: UserEnumDTO[];
  formHandler: UseFormHookResult;
  disabled?: boolean;
};

const MailMethodSubForm = ({ mailMethods, formHandler, disabled }: Props) => {
  //translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // form hook props
  const { bindCheckField, getFormValue, setFormValue, errors } = {
    ...formHandler,
  };

  // side-effects
  // set default mail method (if is only one)
  useEffect(() => {
    if (mailMethods.length === 1) {
      const method = getMailMethod();
      if (!method) {
        setFormValue("mailMethodCode", mailMethods[0].code);
      }
    }
  }, []);

  // helpers
  const isEmailMethod = () => {
    const method = getFormValue<string>("mailMethodCode");
    return method === "Email";
  };

  const getMailMethod = () => { 
    return getFormValue<string>("mailMethodCode");
  }

  // sub-renders
  const renderMailMethods = () => {
    return mailMethods.map((method) => (
      <div className="col-sm-6 col-md-3 px-2" key={method.code}>
        <RadioBox
          label={method.name!}
          icon={{ icon: "paper-plane" }}
          {...bindCheckField("mailMethodCode", method.code)}
          className="mb-sm-0"
          heightAsFormControl
          disabled={disabled}
        />
      </div>
    ));
  };

  // render
  return (
    <PageCard
      title={tLabels("mailMethodSubForm.cardTitle")}
      bodyClassName="pt-4 px-4"
      cardClassName="mb-4"
    >
      <div className="row mx-n2">
        <div className="col-12 px-2">
          <FormGroup
            labelText={tLabels("mailMethodSubForm.mailMethodCode.label")}
            validationError={errors["mailMethodCode"]}
          >
            <div className="row mx-n2">{renderMailMethods()}</div>
          </FormGroup>
        </div>
      </div>
      <RenderWrapper isVisible={isEmailMethod}>
        <MailMethodEmailsSubForm 
          formHandler={formHandler} 
          disabled={disabled}
        />
      </RenderWrapper>
    </PageCard>
  );
};

export default MailMethodSubForm;
